// An operation's photos in the office op panel: take/upload one (#photo-btn), the gallery with
// expand/download/delete, and the count badge (updatePhotoBadge, called when an op opens).
// Split out of app.js (docs/split-plan.md, session 1). Needs nothing from app.js.
import { database, storage } from './initFirebase';
import { remove, update } from './trackedDb';
import { get, ref } from 'firebase/database';
import { deleteObject, getDownloadURL, ref as storageRef, uploadBytes } from 'firebase/storage';

document.getElementById('photo-btn').addEventListener('click', async function () {
  const repairNote = "";
  const jobId = document.getElementById('jobId').value;

  // Basic check for desktop
  const isDesktop = window.innerWidth > 768 && !/Mobi|Android/i.test(navigator.userAgent);

  const handleFileSelection = (captureMode = null) => {
      const fileInput = document.createElement('input');
      fileInput.type = 'file';
      fileInput.accept = 'image/*';
      if (captureMode) {
          fileInput.capture = captureMode;
      }
      fileInput.click();

      fileInput.onchange = async (e) => {
          const file = e.target.files[0];
          if (file) {
              const photoPath = `job_photos/${jobId}/${Date.now()}.jpg`;
              const fileRef = storageRef(storage, photoPath);

              await uploadBytes(fileRef, file);

              const photoData = {
                  note: repairNote,
                  path: photoPath
              };

              const dbRef = ref(database, `data/${jobId}/Photos`);
              const newPhotoKey = Date.now().toString();

              await update(dbRef, {
                  [newPhotoKey]: photoData
              });

              console.log(`Photo uploaded and added to job ${jobId}`);
          }
      };
  };

  if (isDesktop) {
      // Just open file explorer
      handleFileSelection(); // No capture
      return;
  }

  try {
      // Create the popup modal
      const popup = document.createElement('div');
      popup.style.position = 'fixed';
      popup.style.top = '50%';
      popup.style.left = '50%';
      popup.style.transform = 'translate(-50%, -50%)';
      popup.style.background = '#fff';
      popup.style.padding = '40px';
      popup.style.boxShadow = '0 2px 10px rgba(0,0,0,0.3)';
      popup.style.zIndex = '1000';
      popup.style.borderRadius = '8px';
      popup.style.textAlign = 'center';
      popup.style.display = 'flex';
      popup.style.flexDirection = 'column';
      popup.style.alignItems = 'center';
      popup.style.justifyContent = 'center';

      const selectBtn = document.createElement('button');
      selectBtn.innerHTML = '<img src="/assets/file-select.svg" width="24px" height="24px"> Select a Photo';
      selectBtn.className = 'camera-btn';
      popup.appendChild(selectBtn);

      const takeBtn = document.createElement('button');
      takeBtn.innerHTML = '<img src="/assets/camera.svg" width="24px" height="24px"> Take a Photo';
      takeBtn.className = 'camera-btn';
      popup.appendChild(takeBtn);

      const cancelBtn = document.createElement('button');
      cancelBtn.textContent = 'Cancel';
      cancelBtn.style.backgroundColor = 'red';
      cancelBtn.style.color = 'white';
      cancelBtn.className = 'camera-btn';
      popup.appendChild(cancelBtn);

      document.body.appendChild(popup);

      selectBtn.addEventListener('click', (e) => {
          e.stopPropagation();
          document.body.removeChild(popup);
          handleFileSelection(); // No capture mode, open gallery
      });

      takeBtn.addEventListener('click', (e) => {
          e.stopPropagation();
          document.body.removeChild(popup);
          handleFileSelection('environment'); // Open camera
      });

      cancelBtn.addEventListener('click', (e) => {
          e.stopPropagation();
          document.body.removeChild(popup);
      });

  } catch (error) {
      console.error('Error capturing or uploading photo:', error);
  }
});



document.getElementById('photo-gallery-open').addEventListener('click', async function() {
    const jobId = document.getElementById('jobId').value;
    await displayJobPhotos(jobId);
});

async function displayJobPhotos(jobId) {
    try {
        const dbRef = ref(database, `data/${jobId}/Photos`);
        const snapshot = await get(dbRef);

        const photoGallery = document.getElementById('photo-gallery');

        if (!snapshot.exists()) {
            photoGallery.innerHTML = '<div class="contracts-empty">No photos yet for this job.</div>';
            document.getElementById('photoModal').style.display = 'flex';
            return;
        }

        photoGallery.innerHTML = '';

        const photos = snapshot.val();
        const photoPromises = Object.entries(photos).map(async ([key, photo]) => {
            try {
                const url = await getDownloadURL(storageRef(storage, photo.path));
                return { key, url, note: photo.note, path: photo.path };
            } catch (err) {
                console.error('Error fetching photo URL:', err);
                return null;
            }
        });

        const photoData = await Promise.all(photoPromises);

        photoData.forEach(photo => {
            if (photo) {
                const photoCard = document.createElement('div');
                photoCard.classList.add('photo-card');

                const img = document.createElement('img');
                img.src = photo.url;
                img.alt = photo.note || 'Photo';
                img.title = photo.note || 'Photo';
                img.onclick = () => expandPhoto(photo.url);
                photoCard.appendChild(img);

                const photoDate = document.createElement('p');
                photoDate.classList.add('photo-date');
                const date = new Date(parseInt(photo.key)).toLocaleDateString('en-US', {
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit',
                });
                photoDate.textContent = date;
                photoCard.appendChild(photoDate);

                const buttonContainer = document.createElement('div');
                buttonContainer.classList.add('photo-buttons');

                // Delete Button
                const deleteButton = document.createElement('button');
                deleteButton.innerHTML = '🗑️';
                deleteButton.onclick = () => deletePhoto(jobId, photo.key, photo.path, photoCard);

                // Expand Button
                const expandButton = document.createElement('button');
                expandButton.innerHTML = '🔍';
                expandButton.onclick = () => expandPhoto(photo.url);

                // Download Button
                const downloadButton = document.createElement('button');
                downloadButton.innerHTML = '⬇️';
                downloadButton.onclick = () => downloadPhoto(photo.url, photo.note);

                buttonContainer.appendChild(deleteButton);
                buttonContainer.appendChild(downloadButton);

                photoCard.appendChild(buttonContainer);
                photoGallery.appendChild(photoCard);
            }
        });

        document.getElementById('photoModal').style.display = 'flex';
    } catch (error) {
        console.error('Error fetching photos:', error);
    }
}

// Delete Photo Function
async function deletePhoto(jobId, photoKey, photoPath, photoCard) {
    const confirmDelete = confirm('Are you sure you want to delete this photo? This action cannot be undone.');
    if (!confirmDelete) return;

    try {
        // Delete from Firebase Storage
        const fileRef = storageRef(storage, photoPath);
        await deleteObject(fileRef);

        // Delete from Firebase Realtime Database
        const dbRef = ref(database, `data/${jobId}/Photos/${photoKey}`);
        await remove(dbRef);

        // Remove from UI
        photoCard.remove();
        document.getElementById('photo-count').textContent = document.getElementById('photo-count').textContent - 1;
        console.log('Photo deleted successfully');
    } catch (error) {
        console.error('Error deleting photo:', error);
    }
}

// Expand Photo Function
function expandPhoto(url) {
  window.open(url, '_blank');
}

// Download Photo Function
function downloadPhoto(url, note) {
    const fileName = note ? note.replace(/\s+/g, '_') + '.jpg' : 'image.jpg';

    fetch(url)
        .then(response => response.blob())
        .then(blob => {
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = fileName;
            link.click();
            URL.revokeObjectURL(link.href);
        })
        .catch(err => console.error('Error downloading image:', err));
}

document.querySelector('.image-modal-close').addEventListener('click', () => {
    document.getElementById('image-modal').style.display = 'none';
});

window.addEventListener('click', (event) => {



    const popup = document.getElementById('photo-popup');
    const imageModal = document.getElementById('image-modal');

    if (event.target === popup) {
        popup.style.display = 'none';
    }

    if (event.target === imageModal) {
        imageModal.style.display = 'none';
    }
});


export async function updatePhotoBadge(jobId, data) {
  const photoBadge = document.getElementById('photo-count');

  if (data.Photos) {
      const dbRef = ref(database, `data/${jobId}/Photos`);
      try {
          const snapshot = await get(dbRef);

          if (!snapshot.exists()) {
              photoBadge.style.visibility = 'hidden';
              return;
          }

          const photoCount = Object.keys(snapshot.val()).length;

          if (photoCount > 0) {
              photoBadge.textContent = photoCount;
              photoBadge.style.visibility = 'visible';
          } else {
              photoBadge.style.visibility = 'hidden';
          }
      } catch (error) {
          console.error("Error fetching photos:", error);
          photoBadge.style.visibility = 'hidden';
      }
  } else {
      photoBadge.style.visibility = 'hidden';
  }
}
